function normalizeBiblabels(payload) {
  const records = Array.isArray(payload)
    ? payload
    : payload && Array.isArray(payload.results)
      ? payload.results
      : null

  if (!records) {
    throw new Error('Bibliography labels must be an array or a results array')
  }

  return records.map((record, index) => {
    const normalized = Array.isArray(record)
      ? {id: record[0], label: record[1]}
      : record

    if (!normalized || typeof normalized !== 'object') {
      throw new Error(`Bibliography label ${index + 1} is not a record`)
    }
    if (normalized.id === null || normalized.id === undefined) {
      throw new Error(`Bibliography label ${index + 1} has no id`)
    }
    if (typeof normalized.label !== 'string' || !normalized.label.trim()) {
      throw new Error(`Bibliography label ${index + 1} has no label text`)
    }

    return {
      ...normalized,
      id: normalized.id,
      label: normalized.label,
    }
  })
}

function normalizeBiblabelSelection(selection, biblabels) {
  if (!biblabels.length) {
    return []
  }

  const labels = new Set(biblabels.map(biblabel => biblabel.label))
  const labelsById = new Map(
    biblabels.map(biblabel => [String(biblabel.id), biblabel.label])
  )
  const normalized = []

  for (const value of Array.isArray(selection) ? selection : []) {
    const stringValue = String(value)
    const label = labels.has(stringValue)
      ? stringValue
      : labelsById.get(stringValue)
    if (label && !normalized.includes(label)) {
      normalized.push(label)
    }
  }

  return normalized.length
    ? normalized
    : biblabels.map(biblabel => biblabel.label)
}

function biblabelValues(value) {
  if (Array.isArray(value)) {
    return value.reduce(
      (labels, item) => labels.concat(biblabelValues(item)),
      []
    )
  }
  if (value && typeof value === 'object') {
    return biblabelValues(value.label)
  }
  if (typeof value !== 'string') {
    return []
  }
  return value
    .split(',')
    .map(label => label.trim())
    .filter(Boolean)
}

function matchesSelectedBiblabels(value, selection) {
  const selected = new Set(
    (Array.isArray(selection) ? selection : []).map(String)
  )
  if (!selected.size) {
    return true
  }
  return biblabelValues(value).some(label => selected.has(String(label)))
}

export {
  biblabelValues,
  matchesSelectedBiblabels,
  normalizeBiblabels,
  normalizeBiblabelSelection,
}
